import React from "react"
import classes from "./Header.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/pro-regular-svg-icons"
import DropdownMenu from "./dropdown"
import SideDrawer from "./sideDrawer"
import { AuthConsumer } from "../../context/auth/authContext"
import LogoutAlias from "./logoutAlias"
import WelcomeAlert from "./welcomeAlert"
import { Link } from "gatsby"
import { Row } from "react-bootstrap"
import _ from "lodash"
import { PageContext } from "gatsby/internal"

interface IHeader {
  pageContext: PageContext
}

const Header: React.FC<IHeader> = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } =
    typeof window !== "undefined" && pageContext.breadcrumb
      ? pageContext
      : { breadcrumb: { crumbs: [] } }
  const [modalOpen, setModalOpen] = React.useState(false)

  const toggleModalHandler = () => {
    setModalOpen(prevState => !prevState)
  }
  return (
    <AuthConsumer>
      {context =>
        context.authenticated && (
          <>
            <header className={classes.headerRoot}>
              {process.env.GATSBY_ACTIVE_ENV === "qa" && (
                <p className="bg-danger small">QA</p>
              )}
              {process.env.GATSBY_ACTIVE_ENV === "staging" && (
                <p className="bg-warning small">Staging</p>
              )}
              {/*<div className={classes.headerContent}>*/}
              {/*  <p className={classes.contentParagraph}>{temp}º</p>*/}
              {/*  <p className={classes.hossParagraph}>HOSS</p>*/}
              {/*  <p className={classes.contentParagraph}>{dateToday}</p>*/}
              {/*</div>*/}
              <div className={classes.headerBottomRow}>
                <div className={classes.burgerHome}>
                  <FontAwesomeIcon
                    icon={modalOpen ? faTimes : faBars}
                    className={classes.icon}
                    onClick={toggleModalHandler}
                  />
                  {crumbs &&
                    crumbs.map(
                      (crumb, index) =>
                        index !== 0 && (
                          <p className="text-dark" key={index}>
                            {index === 1 ? "" : "/"}
                            {index !== crumbs.length - 1 ? (
                              <Link to={crumb.pathname}>
                                {_.startCase(crumb.crumbLabel)}
                              </Link>
                            ) : (
                              _.startCase(crumb.crumbLabel)
                            )}
                          </p>
                        )
                    )}
                </div>
                <Row className="flex-row">
                  {context.aliased ? <LogoutAlias /> : <WelcomeAlert />}
                  <DropdownMenu />
                </Row>
              </div>
            </header>
            <SideDrawer modalOpen={modalOpen} onClick={toggleModalHandler} />
          </>
        )
      }
    </AuthConsumer>
  )
}

export default Header
